import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomerTypeReference');
  }
}
